import React from 'react';

import { Content } from './Content.js';

export default class ParagraphWithAnchor extends React.Component {

  render() {
    return (
      <p>
        {Content[this.props.page].body2}
        &nbsp;
        <a href={Content[this.props.page].anchorHref}>{Content[this.props.page].anchorText}</a>
        &nbsp;
        {Content[this.props.page].signOff}
      </p>
    );
  }

};
